export const AUDIENCE_SORT_TYPES = ['top', 'earliest'] as const;
export type AudienceSortType = (typeof AUDIENCE_SORT_TYPES)[number];
